import type { FunctionComponent, HTMLAttributes, PropsWithChildren } from "react"

import { clsx } from "clsx"

import styles from "./Layout.module.css"

export type LayoutChildProps = PropsWithChildren<{
  as?: "div" | "article" | "section" | "main" | "header" | "footer" | "li"
  className?: string
  variant?: "full" | "large" | "medium"
}> &
  HTMLAttributes<HTMLElement>

type LayoutChildPropsWithoutFromAndTo = LayoutChildProps & {
  from?: never
  to?: never
}

type LayoutChildPropsWithFromAndTo = LayoutChildProps & {
  from: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  to: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
}

export const LayoutChild: FunctionComponent<LayoutChildPropsWithoutFromAndTo | LayoutChildPropsWithFromAndTo> = ({
  as: LayoutChildComponent = "div",
  children,
  className,
  from,
  to,
  variant,
  ...props
}) => {
  const layoutChildClassNames = clsx(
    {
      [styles.layout__child___full]: variant === "full",
      [styles.layout__child___large]: variant === "large",
      [styles.layout__child___medium]: variant === "medium",
      [styles.layout__child___custom]: from && to,
    },
    className
  )

  return (
    <LayoutChildComponent
      {...props}
      {...(from && to
        ? // Reat.CSSPRoperties type cannot be applied with all the ReactHTML elements
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ({ style: { "--layout-child-from": from, "--layout-child-to": to + 1 } } as any)
        : {})}
      className={layoutChildClassNames}
    >
      {children}
    </LayoutChildComponent>
  )
}
